import React from 'react'
import PropTypes from 'prop-types'
import { Copy } from '@elparking/components'
const CurrencyWrapper = ({ children }) =>
    <Copy as='span' padding='0' fontSize='large' fontColor='accent_dark'>
        {children}
    </Copy>

CurrencyWrapper.propTypes = {
    children: PropTypes.node,
}

export default CurrencyWrapper
